import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import style from './Styles/index.module.scss'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { logout } from '../../../store/async-thunks/auth/logout'

export const LogoutButton = () => {
    const dispatch = useAppDispatch()
    const onLogout = () => dispatch(logout())

    return (
        <button
            type="button"
            onClick={onLogout}
            className={style.button}
        >
            <FontAwesomeIcon
                icon={faArrowRightFromBracket}
                size="lg"
            />
        </button>
    )
}